import {
  IAction,
  KEEP_THE_SAME,
  StateStatus,
} from '../../../redux/utils/common';
import * as Types from './types';

interface IState {
  ReimbursementsList: {
    status: StateStatus | null;
    data: any;
  };
  unreadNotificationCount: {
    status: StateStatus | null;
    data: number;
  };
}

const initialState: IState = {
  ReimbursementsList: {
    status: null,
    data: null,
  },
  unreadNotificationCount: {
    status: null,
    data: 0,
  },
};

const ReimbursementsListReducer = (
  state: IState = initialState,
  action: IAction
): IState => {
  switch (action.type) {
    case Types.SET_REIMBURSEMENT_LIST:
      return {
        ...state,
        ReimbursementsList: {
          ...state.ReimbursementsList,
          status: action.status || null,
          data:
            action.data === KEEP_THE_SAME
              ? state.ReimbursementsList.data
              : action.data,
        },
      };
    case Types.SET_UNREAD_NOTIFICATION_COUNT:
      return {
        ...state,
        unreadNotificationCount: {
          status: action.status || null,
          data:
            action.data === KEEP_THE_SAME
              ? state.unreadNotificationCount.data
              : action.data,
        },
      };
    default:
      return {
        ...state,
      };
  }
};

export default ReimbursementsListReducer;

/**
 * Add new Page Steps:
 *
 * navigation -> config -> index.tsx
 * navigation -> config -> Routes.tsx
 *
 */
